module.exports = __webpack_public_path__ + "static/storm_static-228790eef19689daa60e868a3cefdc26.png";